import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CombinedOrdersComponent } from '../../../shared/components/combined-orders/combined-orders.component';
import { StoreConfig, STORES } from '../../../shared/config/store-config';

@Component({
    selector: 'app-all-orders',
    templateUrl: './all-orders.component.html',
    styleUrls: ['./all-orders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CombinedOrdersComponent],
})
export class AllOrdersComponent {
    // Every registered store, in tab order. StoreRegistryService checks each
    // storeId against GET /v1/stores on load and disables recording receipt
    // info for any it doesn't find — see store-config.ts for why the ids are
    // not ours to change.
    stores: StoreConfig[] = STORES;
}
